"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
function filterDefaultValues(keyMapping, defaultValues) {
    if (!defaultValues) {
        return null;
    }
    var defaultState = {};
    Object.keys(keyMapping).forEach(function (prop) { return (defaultState[prop] = defaultValues[prop]); });
    return defaultState;
}
function extractTweekValues(_a, currentValues) {
    var valuesMapping = _a.valuesMapping, tweekRepository = _a.tweekRepository, defaultValues = _a.defaultValues, resetOnRepoChange = _a.resetOnRepoChange;
    var filteredDefaultValues = filterDefaultValues(valuesMapping, defaultValues);
    if (!tweekRepository) {
        return resetOnRepoChange || !currentValues ? filteredDefaultValues : currentValues;
    }
    var newValues = filteredDefaultValues || {};
    for (var _i = 0, _b = Object.entries(valuesMapping); _i < _b.length; _i++) {
        var _c = _b[_i], prop = _c[0], keyPath = _c[1];
        var cachedKey = tweekRepository.getCached(keyPath);
        if (!cachedKey) {
            tweekRepository.prepare(keyPath);
        }
        if (cachedKey && cachedKey.state !== "requested") {
            if (cachedKey.state !== "missing") {
                newValues[prop] = cachedKey.value;
            }
        }
        else if (!filteredDefaultValues) {
            if (resetOnRepoChange || !currentValues) {
                return null;
            }
            newValues[prop] = currentValues[prop];
        }
    }
    return newValues;
}
var TweekValues = (function (_super) {
    __extends(TweekValues, _super);
    function TweekValues(props) {
        var _this = _super.call(this, props) || this;
        _this._dispose = null;
        _this._setKeysState = function (updatedKeys) {
            if (updatedKeys && !_this.state.tweekKeys.some(function (key) { return updatedKeys.has(key); })) {
                return;
            }
            _this.setState(function (_a, props) {
                var currentValues = _a.tweekValues;
                var tweekValues = extractTweekValues(props, currentValues);
                return lodash_isequal_1.default(tweekValues, currentValues) ? null : { tweekValues: tweekValues };
            });
        };
        _this.state = {
            tweekValues: extractTweekValues(_this.props, null),
            tweekKeys: Object.values(_this.props.valuesMapping),
        };
        return _this;
    }
    TweekValues.prototype.componentDidMount = function () {
        this._subscribeToKeys();
        var tweekValues = extractTweekValues(this.props, null);
        if (!lodash_isequal_1.default(this.state.tweekValues, tweekValues)) {
            this.setState({ tweekValues: tweekValues });
        }
    };
    TweekValues.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.valuesMapping !== this.props.valuesMapping) {
            this.setState(function (_a, props) {
                var currentKeys = _a.tweekKeys;
                var tweekKeys = Object.values(props.valuesMapping);
                return lodash_isequal_1.default(currentKeys, tweekKeys) ? null : { tweekKeys: tweekKeys };
            });
        }
        if (prevProps.tweekRepository !== this.props.tweekRepository) {
            this._unsubscribe();
            this._subscribeToKeys();
            this._setKeysState();
        }
    };
    TweekValues.prototype.componentWillUnmount = function () {
        this._unsubscribe();
    };
    TweekValues.prototype._subscribeToKeys = function () {
        var tweekRepository = this.props.tweekRepository;
        if (!tweekRepository) {
            return;
        }
        this._dispose = tweekRepository.listen(this._setKeysState);
    };
    TweekValues.prototype._unsubscribe = function () {
        this._dispose && this._dispose();
        this._dispose = null;
    };
    TweekValues.prototype.render = function () {
        var tweekValues = this.state.tweekValues;
        if (!tweekValues) {
            return null;
        }
        return this.props.children(tweekValues);
    };
    return TweekValues;
}(react_1.Component));
exports.TweekValues = TweekValues;
//# sourceMappingURL=TweekValues.js.map


// WEBPACK FOOTER //
// ../src/TweekValues.tsx